import { Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomNavigationService {

  constructor(private router: Router) {}

  navigate(url: string | UrlTree, extras: NavigationExtras = {}): Promise<boolean> {
    // Navigate using skipLocationChange to hide the actual route
    return this.router.navigateByUrl(url, { ...extras, skipLocationChange: true });
  }
}
